// src/pages/Dashboard/widgets/OkrStatusWidget.tsx
import React, { useEffect, useState } from 'react';
import { Pie } from '@ant-design/plots';
import { RootState } from '../../../app/store';
import { useSelector } from 'react-redux';

interface OkrStatusWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

interface StatusDatum {
    title: string;
    ratio: number;
}

const OkrStatusWidget: React.FC<OkrStatusWidgetProps> = ({ rowSpan = 1, colSpan = 1 }) => {
    const themeColors = useSelector((state: RootState) => state.app?.themeColors);
    const [data, setData] = useState<StatusDatum[]>([]);

    useEffect(() => {
        // Şimdilik dummy data
        setData([
            { title: 'Hedefin Üzerinde Başarı', ratio: 55.6 },
            { title: 'Hedefe Uygun Başarı', ratio: 33.4 },
            { title: 'Riskli Hedef', ratio: 11 },
        ]);
    }, []);

    if (!data.length) return null;

    // İç chart'ın boyutuna göre radius ayarı (örn. küçük alanda %80)
    const size = Math.min(colSpan * 120, rowSpan * 120);
    const radius = size / 2 / (size / 100) * 0.8;

    const config = {
        angleField: 'ratio',
        colorField: 'title',
        // @ts-ignore
        data: data,
        scale: {
            color: { range: ['#00CCCC', '#D1E231', '#C0C0C0'] },
        },
        label: {
            text: (d: any) => `${d.ratio}%`,
            position: "inside",
            style: {
                fontWeight: 'bold',
                fill: "#003262"
            },
        },
        style: {
            stroke: '#fff',
            inset: 1,
            radius: 10,
        },
        innerRadius: 0.6,
        legend: {
            color: {
                title: true,
                position: 'bottom',
                rowPadding: 5,
            },
        },
        tooltip: {
            title: 'title',
            items: [{name: '', field: "ratio", valueFormatter: (d: any) => `${d} %`}],
        },
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: {opacity: 0.5},
        },
    };

    return (
        <div className="h-full w-full p-4 bg-white rounded shadow flex flex-col">
            <h2 className="text-lg font-semibold text-center mb-4">OKR Durumları (Hedef İlerlemelere Göre)</h2>
            <div style={{ width: size, height: size, margin: '0 auto' }}>
                <Pie {...config} />
            </div>
        </div>
    );
};

export default OkrStatusWidget;
